import { render } from "./FAQClientItem.vue?vue&type=template&id=77417bd2&scoped=true"
import script from "./FAQClientItem.vue?vue&type=script&lang=js"
export * from "./FAQClientItem.vue?vue&type=script&lang=js"

import "./FAQClientItem.vue?vue&type=style&index=0&id=77417bd2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-77417bd2"

export default script